import jsonToView from '../../api/json-to-view';
import calculateDistanceLngLat from './calculate-distance-lnglat';

export default function buildSpotsList(
  data,
  orderDataByDistance,
  showDistances,
  allMarkers,
  searchedPlaceLat,
  searchedPlaceLng
) {
  if (!data || !data.features) {
    return;
  }

  let arrOfSpots = [];

  data.features.forEach(feature => {
    feature.properties.forEach((property, index) => {
      if (property.Latitude != null || property.Longitude != null) {
        if (orderDataByDistance) {
          const fromLat = Number(property.Latitude.replace(',', '.'));
          const fromLng = Number(property.Longitude.replace(',', '.'));
          const toLat = Number(searchedPlaceLat);
          const toLng = Number(searchedPlaceLng);

          const distanceValue = calculateDistanceLngLat(fromLat, fromLng, toLat, toLng)
            .toFixed(1)
            .replace('.', ',');

          property.Distance = distanceValue;
        }
        arrOfSpots.push(property);
      } else {
        delete property[index];
      }
    });
  });

  arrOfSpots.sort((a, b) => {
    let nameA;
    let nameB;
    if (orderDataByDistance) {
      nameA = Number(a.Distance.replace(',', '.'));
      nameB = Number(b.Distance.replace(',', '.'));
    } else {
      nameA = a.CompanyName.toUpperCase();
      nameB = b.CompanyName.toUpperCase();
    }
    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  });

  arrOfSpots = arrOfSpots.filter(
    (spot, index, self) => self.findIndex(t => t.Id === spot.Id) === index
  );

  const list = document.querySelector(
    '[data-module="Locator__A"] [data-child-module="Locator__LocationList"]'
  );
  list.innerHTML = '';

  arrOfSpots.forEach(spotItem => {
    const listItem = document.createElement('li');
    listItem.classList.add('c-locationlist__item', 'js-locationlist-item');

    const templateView = 'LocatorSpotListItem';
    jsonToView(spotItem, templateView).then(result => {
      listItem.innerHTML = result;
    });
    list.appendChild(listItem);

    listItem.addEventListener('click', () => {
      const indexOfMarker = allMarkers.findIndex(x => x.id === spotItem.Id);
      google.maps.event.trigger(allMarkers[indexOfMarker], 'click');

      if (window.innerWidth <= 768) {
        const map = document.getElementById('locations-section');
        if (!map) return;
        const offset = 100;
        const elementPosition = map.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      }
    });

    if (showDistances) {
      setTimeout(() => {
        const distances = document.querySelectorAll('[data-module="Locator__LocationDistance"]');
        distances.forEach(distance => {
          distance.removeAttribute('style');
        });
      }, 2000);
    }
  });
}
